/**
 * Shared dashboard HTML helpers used by screen slices.
 */
import { formatInteger } from "./format.js";

export function detailMetric(label: string, value: string): string {
  return `<div><span>${escapeHtml(label)}</span><strong>${escapeHtml(value)}</strong></div>`;
}

export function pill(label: string, status: string): string {
  return `<span class="pill ${escapeAttr(status)}">${escapeHtml(label)}</span>`;
}

export function labelize(value: string): string {
  if (value === "none") return "none";
  return value.replaceAll("_", " ");
}

export function safeDateTimeLabel(value: string | null | undefined): string {
  if (!value) return "time pending";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

export function barWidth(value: number | null): string {
  if (value === null || !Number.isFinite(value)) return "0";
  return String(Math.max(0, Math.min(100, value * 100)));
}

export function formatNullable(value: number | null): string {
  return value === null ? "n/a" : formatInteger(value);
}

export function shortUri(uri: string): string {
  if (uri.length <= 64) return uri;
  return `${uri.slice(0, 28)}...${uri.slice(-28)}`;
}

export function escapeHtml(value: unknown): string {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function escapeAttr(value: unknown): string {
  return escapeHtml(value);
}

export function metric(label: string, value: string, note: string, state: string): string {
  return `
    <article class="metric ${escapeAttr(state)}">
      <span>${escapeHtml(label)}</span>
      <strong>${escapeHtml(value)}</strong>
      <small>${escapeHtml(note)}</small>
    </article>
  `;
}
